import { ZorgtoeslagRates } from './interface';

export const rates: ZorgtoeslagRates = {
    withoutPartner: {
        2022: [
            { to: 22000, base: 111 },
            { to: 22500, base: 109 },
            { to: 23000, base: 104 },
            { to: 23500, base: 98 },
            { to: 24000, base: 92 },
            { to: 24500, base: 87 },
            { to: 25000, base: 81 },
            { to: 25500, base: 75 },
            { to: 26000, base: 69 },
            { to: 26500, base: 64 },
            { to: 27000, base: 58 },
            { to: 27500, base: 52 },
            { to: 28000, base: 47 },
            { to: 28500, base: 41 },
            { to: 29000, base: 35 },
            { to: 29500, base: 30 },
            { to: 30000, base: 24 },
            { to: 30500, base: 18 },
            { to: 31000, base: 13 },
            { to: 31500, base: 7 },
        ],
        2021: [
            { to: 21500, base: 107 },
            { to: 22000, base: 105 },
            { to: 22500, base: 99 },
            { to: 23000, base: 94 },
            { to: 23500, base: 88 },
            { to: 24000, base: 82 },
            { to: 24500, base: 77 },
            { to: 25000, base: 71 },
            { to: 25500, base: 65 },
            { to: 26000, base: 60 },
            { to: 26500, base: 54 },
            { to: 27000, base: 48 },
            { to: 27500, base: 43 },
            { to: 28000, base: 37 },
            { to: 28500, base: 31 },
            { to: 29000, base: 26 },
            { to: 29500, base: 20 },
            { to: 30000, base: 14 },
            { to: 30500, base: 9 },
            { to: 31000, base: 3 },
        ],
        2020: [
            { to: 21000, base: 104 },
            { to: 21500, base: 103 },
            { to: 22000, base: 97 },
            { to: 22500, base: 92 },
            { to: 23000, base: 86 },
            { to: 23500, base: 80 },
            { to: 24000, base: 75 },
            { to: 24500, base: 69 },
            { to: 25000, base: 63 },
            { to: 25500, base: 58 },
            { to: 26000, base: 52 },
            { to: 26500, base: 46 },
            { to: 27000, base: 41 },
            { to: 27500, base: 35 },
            { to: 28000, base: 29 },
            { to: 28500, base: 24 },
            { to: 29000, base: 18 },
            { to: 29500, base: 13 },
            { to: 30000, base: 7 }
        ],
        2019: [
            { to: 20500, base: 99 },
            { to: 21000, base: 98 },
            { to: 21500, base: 92 },
            { to: 22000, base: 87 },
            { to: 22500, base: 81 },
            { to: 23000, base: 75 },
            { to: 23500, base: 70 },
            { to: 24000, base: 64 },
            { to: 24500, base: 58 },
            { to: 25000, base: 53 },
            { to: 25500, base: 47 },
            { to: 26000, base: 42 },
            { to: 26500, base: 36 },
            { to: 27000, base: 30 },
            { to: 27500, base: 25 },
            { to: 28000, base: 19 },
            { to: 28500, base: 13 },
            { to: 29000, base: 8 },
            { to: 29500, base: 2 },
        ]
    },
    withPartner: {
        2022: [
            { to: 22000, base: 212 },
            { to: 22500, base: 211 },
            { to: 23000, base: 205 },
            { to: 23500, base: 199 },
            { to: 24000, base: 194 },
            { to: 24500, base: 188 },
            { to: 25000, base: 182 },
            { to: 25500, base: 177 },
            { to: 26000, base: 171 },
            { to: 26500, base: 165 },
            { to: 27000, base: 160 },
            { to: 27500, base: 154 },
            { to: 28000, base: 148 },
            { to: 28500, base: 143 },
            { to: 29000, base: 137 },
            { to: 29500, base: 131 },
            { to: 30000, base: 126 },
            { to: 30500, base: 120 },
            { to: 31000, base: 114 },
            { to: 31500, base: 109 },
            { to: 32000, base: 103 },
            { to: 32500, base: 97 },
            { to: 33000, base: 92 },
            { to: 33500, base: 86 },
            { to: 34000, base: 80 },
            { to: 34500, base: 75 },
            { to: 35000, base: 69 },
            { to: 35500, base: 63 },
            { to: 36000, base: 58 },
            { to: 36500, base: 52 },
            { to: 37000, base: 46 },
            { to: 37500, base: 41 },
            { to: 38000, base: 35 },
            { to: 38500, base: 29 },
            { to: 39000, base: 24 },
            { to: 39500, base: 18 },
            { to: 40000, base: 12 },
            { to: 40500, base: 7 },
        ],
        2021: [
            { to: 21500, base: 207 },
            { to: 22000, base: 205 },
            { to: 22500, base: 199 },
            { to: 23000, base: 194 },
            { to: 23500, base: 188 },
            { to: 24000, base: 182 },
            { to: 24500, base: 177 },
            { to: 25000, base: 171 },
            { to: 25500, base: 165 },
            { to: 26000, base: 160 },
            { to: 26500, base: 154 },
            { to: 27000, base: 148 },
            { to: 27500, base: 143 },
            { to: 28000, base: 137 },
            { to: 28500, base: 131 },
            { to: 29000, base: 126 },
            { to: 29500, base: 120 },
            { to: 30000, base: 114 },
            { to: 30500, base: 109 },
            { to: 31000, base: 103 },
            { to: 31500, base: 97 },
            { to: 32000, base: 92 },
            { to: 32500, base: 86 },
            { to: 33000, base: 80 },
            { to: 33500, base: 75 },
            { to: 34000, base: 69 },
            { to: 34500, base: 63 },
            { to: 35000, base: 58 },
            { to: 35500, base: 52 },
            { to: 36000, base: 46 },
            { to: 36500, base: 41 },
            { to: 37000, base: 35 },
            { to: 37500, base: 30 },
            { to: 38000, base: 24 },
            { to: 38500, base: 18 },
            { to: 39000, base: 13 },
            { to: 39500, base: 7 },
        ],
        2020: [
            { to: 21000, base: 199 },
            { to: 21500, base: 198 },
            { to: 22000, base: 193 },
            { to: 22500, base: 187 },
            { to: 23000, base: 182 },
            { to: 23500, base: 176 },
            { to: 24000, base: 170 },
            { to: 24500, base: 165 },
            { to: 25000, base: 159 },
            { to: 25500, base: 153 },
            { to: 26000, base: 148 },
            { to: 26500, base: 142 },
            { to: 27000, base: 136 },
            { to: 27500, base: 131 },
            { to: 28000, base: 125 },
            { to: 28500, base: 119 },
            { to: 29000, base: 114 },
            { to: 29500, base: 108 },
            { to: 30000, base: 102 },
            { to: 30500, base: 97 },
            { to: 31000, base: 91 },
            { to: 31500, base: 86 },
            { to: 32000, base: 80 },
            { to: 32500, base: 74 },
            { to: 33000, base: 69 },
            { to: 33500, base: 63 },
            { to: 34000, base: 57 },
            { to: 34500, base: 52 },
            { to: 35000, base: 46 },
            { to: 35500, base: 40 },
            { to: 36000, base: 35 },
            { to: 36500, base: 29 },
            { to: 37000, base: 23 },
            { to: 37500, base: 18 },
            { to: 38000, base: 12 },
            { to: 38500, base: 6 },
        ],
        2019: [
            { to: 20500, base: 192 },
            { to: 21000, base: 192 },
            { to: 21500, base: 186 },
            { to: 22000, base: 180 },
            { to: 22500, base: 175 },
            { to: 23000, base: 169 },
            { to: 23500, base: 164 },
            { to: 24000, base: 158 },
            { to: 24500, base: 152 },
            { to: 25000, base: 147 },
            { to: 25500, base: 141 },
            { to: 26000, base: 135 },
            { to: 26500, base: 130 },
            { to: 27000, base: 124 },
            { to: 27500, base: 118 },
            { to: 28000, base: 113 },
            { to: 28500, base: 107 },
            { to: 29000, base: 102 },
            { to: 29500, base: 96 },
            { to: 30000, base: 90 },
            { to: 30500, base: 85 },
            { to: 31000, base: 79 },
            { to: 31500, base: 73 },
            { to: 32000, base: 68 },
            { to: 32500, base: 62 },
            { to: 33000, base: 57 },
            { to: 33500, base: 51 },
            { to: 34000, base: 45 },
            { to: 34500, base: 40 },
            { to: 35000, base: 34 },
            { to: 35500, base: 28 },
            { to: 36000, base: 23 },
            { to: 36500, base: 17 },
            { to: 37000, base: 11 },
            { to: 37500, base: 6 }
        ]
    }
};
